import { useDispatch, useSelector } from "react-redux";
import {sortOption, filterOption} from "../../features/filter/filterSlice";


export default function Filter() {
  const dispatch = useDispatch();
  const filter = useSelector(state=>state.filter);
  const handleRadio = (e)=>{
    dispatch(filterOption(e));
  }
  const handleSelect = (e)=>{
    dispatch(sortOption(e.target.value));
  }
  return (
    <aside>
      <div className="sidebar-items">
        <div className="sidebar-content">
          <h4>Sort</h4>
          <select onChange={handleSelect} value={filter.sort} name="sort" id="lws-sort" className="w-full max-w-[150px] border-2 rounded-md text-gray-500">
            <option value="">Default</option>
            <option value="newest" >Newest</option>
            <option value="liked">Most Liked</option>
          </select>
        </div>
        <div className="sidebar-content">
          <h4>Filter</h4>
          <div className="radio-group">
            <div>
              <input onChange={()=>handleRadio('All')} type="radio" checked={filter.filter === 'All' } name="filter" id="lws-all" className="radio" />
              <label htmlFor="lws-all">All</label>
            </div>
            <div>
              <input onChange={()=>handleRadio('Saved')} type="radio" checked={filter.filter === 'Saved' } name="filter" id="lws-saved" className="radio" />
              <label htmlFor="lws-saved">Saved</label>
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
}
